import { use, useEffect, useState } from "react";
import { Dialog } from "@/components/ui/dialog";
import { UseData } from "@/components/user/lib/services/UseData";
import { AuthContext } from "@/context/AuthContext";
import { onCancelSubscription } from "../../../helpers/onCancelSubscription";
import type { FormType } from "../../../types";
import { CancelSubscriptionForm } from "../CancelSubscriptionForm";
import { CancelSuccessForm } from "../CancelSuccessForm";

type Props = {
	openModal: boolean;
	setOpenModal: (open: boolean) => void;
	setSubscriptionWillCancel: (value: boolean) => void;
	subscriptionWillCancel: boolean;
};

export const RenderDialogForm: React.FC<Props> = (props) => {
	const {
		openModal,
		setOpenModal,
		setSubscriptionWillCancel,
		subscriptionWillCancel,
	} = props;

	const [formType, setFormType] = useState<FormType>("cancel");
	const context = use(AuthContext);

	const { error: cancelError, execute: cancelSubscription } =
		UseData.create().useDeleteStripeSubscription();

	useEffect(() => {
		if (!subscriptionWillCancel) {
			setFormType("cancel");
		}
	}, [subscriptionWillCancel]);

	const mapForm: Record<FormType, React.JSX.Element> = {
		cancel: (
			<CancelSubscriptionForm
				cancelError={cancelError}
				cancelSubscription={(setCancelLoader) =>
					onCancelSubscription({
						cancelSubscription,
						setCancelLoader,
						setFormType,
						setSubscriptionWillCancel,
						context,
					})
				}
			/>
		),
		success: <CancelSuccessForm />,
	};
	return (
		<Dialog
			open={openModal}
			onOpenChange={(open) => {
				setOpenModal(false);
				if (!open) {
					setFormType("cancel");
				}
			}}
		>
			{mapForm[formType]}
		</Dialog>
	);
};
